import { apiClient } from '../api-client';

export const createHardwareRequest = async (getToken, { title, description }) =>
  apiClient('POST', '/requests/hardware', getToken, {
    title,
    description,
  });
